<template>
    <MainLayout>
		<div class="container">
            <div class="box">
                <b-row>
					<b-col>
						<h2 class="inline-heading">{{ $t('global.importReservations') }}</h2>
					</b-col>
                    <b-overlay :show="loading" no-wrap rounded></b-overlay>
                    <b-col class="col-md-6">
                        <b-form-group class="d-flex justify-content-end">
                            <b-button class="mr-2 btn-success" :href="downloadFormatURL" target="_blank"><md-icon icon="download"/> {{ $t('global.downloadFormat') }}</b-button>
                        </b-form-group>
					</b-col>
				</b-row>

                <hr/>

                <b-row>
                    <b-form-group :label="$t('global.file')+':'" class="col-md-12">
                        <input type="file" id="file" ref="file" @change="handleFileUpload()"/>
                    </b-form-group>
                    <b-form-group :label="$t('global.dateFormat')+':'" class="col-md-3">
                        <b-form-select v-model="dateFormat" :id="dateFormat" :options="dateFormats"></b-form-select>
                    </b-form-group>
                    <b-form-group :label="$t('global.timeFormat')+':'" class="col-md-3">
                        <b-form-select v-model="timeFormat" :id="timeFormat" :options="timeFormats"></b-form-select>
                    </b-form-group>
                    <b-form-group class="pt-2 col-md-3">
                        <b-button variant="dark" class="mt-3" @click="submitFile()"><md-icon icon="library_add"/> {{ $t('global.validateInformation') }}</b-button>
                    </b-form-group>
                </b-row>

                <!-- Show error list -->
                <label class="text-danger" v-if="corrections">{{ $t('global.errorsFound') }}</label>
                <ul v-if="message != ''">
                    <li>{{ message }}</li>
                </ul>

                <!-- Table view -->
                 <b-table v-if="errors.length" striped hover small bordered responsive :items="errors" ref="table"
                    show-empty :empty-text="$t('global.ajaxTable.noRecordsFound')">
                    <!-- A custom formatted column -->
                    <template #cell(errores)="data">
                         <ul>
                            <li v-for="(error, index) in data.value" :key="index">
                                <small>{{ error }}</small>
                            </li>
                        </ul>
                    </template>
                </b-table>

                <!-- End error list -->
			</div>

            <br>
            <div class="box">
                <section id="success" v-if="bookingsCreated.length > 0">
                    <b-button variant="outline-primary" size="lg" @click="bookingsCreated=[]">
						<md-icon icon="arrow_back"></md-icon> Continuar Importando Reservas
					</b-button>
					<b-alert show variant="success" dismissible class="text-center mt-2">
						<b>Se crearón correctamente las reservas</b>
					</b-alert>

					<b-table striped hover small bordered responsive :items="bookingsCreated" class="text-nowrap borderless mt-3" ref="table-reservations-created"
						show-empty empty-text="No se encontraron datos" :tbody-tr-class="rowClass">
						<template #cell(scReservationId)="data">
							<b-button @click="resView({id:null,reservationId:data.item.scReservationId})" variant="outline-success">
								<span>Ver reservación</span>
							</b-button>
						</template>
					</b-table>
                </section>
                <section v-else>
                    <div v-if="mapping">
                        <label>{{ $t('global.selectOption') }}</label>
                        <div class="row p-2">
                            <h5 class="col-md-12">{{ $t('global.typesServices') }}</h5>
                            <div class="d-flex col-md-12 justify-content-between" v-for="(serviceType, index) in serviceTypes" :key="serviceType">
                                <div class="p-2 w-25">
                                    <label>{{ serviceType }} : </label>
                                    <b-input-group>
                                        <b-form-select v-model="typeSelects[index].model" :options="serviceTypesMap" :id="'service-type-' + index">
                                        </b-form-select>
                                        <b-input-group-append>
                                            <b-button variant="success" v-if="!$root.isEmpty(typeSelects[index].model)">
                                                <span><md-icon icon="check"></md-icon></span>
                                            </b-button>
                                            <b-button variant="warning" v-else class="__shake">
                                                <span><md-icon icon="info"></md-icon></span>
                                            </b-button>
                                        </b-input-group-append>
                                    </b-input-group>
                                </div>
                            </div>
                        </div>
                        <hr>
                        <b-row v-if="placemapping" class="p-2">
                            <h5 class="col-md-12">Pickups & Dropoffs</h5>
                            <div class="col-md-12 justify-content-between" v-for="(place, index) in places" :key="place">
                                <search-places class="w-50" @getData="setData" :label="$t('global.search')" :place="place" v-model="responses[index].model"></search-places>
                            </div>
                        </b-row>
                    </div>

                    <b-row>
                        <b-col md class="mb-2">
                            <div class="mr-4">
                                <span>{{rowsMessage}}</span>
                                <b-form-select size="sm" class="ml-2" id="perPageSelector" v-model="perPage" :options="perPageOptions" @change="submitFile(false)"></b-form-select>
                            </div>
                        </b-col>
                        <b-col md class="text-right">
                            <b-row no-gutters>
                                <b-col >
                                    <b-pagination v-model="currentPage" align="right" :total-rows="totalRows" :per-page="perPage" @input="submitFile(false)"/>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>

                    <b-table striped hover small bordered responsive :items="items" class="text-nowrap borderless" ref="table"
                        show-empty :empty-text="$t('global.ajaxTable.noRecordsFound')" :tbody-tr-class="rowClass">
                    </b-table>

                    <div class="d-flex justify-content-end">
                        <b-button v-if="mapping" variant="dark" class="mr-2" @click="submitFileMap()"><md-icon icon="library_add"/>Generar reservas</b-button>
                    </div>
                </section>
            </div>
        </div>
        <FormReservation
            ref="single"
            :model-id.sync="resSelected.modalModelId"
            :show.sync="resSelected.show"
            @onCopyRes="copyCurrentRes"
            operated-by="supplier"
		/>
    </MainLayout>
</template>

<script>
    import MainLayout from '../layout/MainLayout.vue'
    import SearchPlaces from './SearchPlaces.vue'
    import FormReservation from './Single.vue'

    export default { components: { MainLayout,  SearchPlaces, FormReservation },
        props: {
            showSelectAll: {
				type : Boolean,
				required: false,
				default : false
			},
            model: {
                type: Array,
                required: false,
            },
            valueType: [String, Object]
        },
        data() {
            return {
                file: '',
                importResult: '',
                showSingleModal: false,
                loading:false,
                items:[],
                dateFormat: 'Y-m-d',
                dateFormats: [
                    {value:'Y-m-d', text:"2024-09-13 (YYYY-mm-dd)"},
                    {value:'d-m-Y', text:"13-09-2024 (dd-mm-YYYY)"},
                    {value:'m-d-Y', text:"09-13-2024 (mm-dd-YYYY)"},
                    {value:'Y/m/d', text:"2024/09/13 (YYYY/mm/dd)"},
                    {value:'d/m/Y', text:"13/09/2024 (dd/mm/YYYY)"},
                    {value:'m/d/Y', text:"09/13/2024 (mm/dd/YYYY)"},

                    {value:'Y-n-j', text:"2024-9-5 (YYYY-m-d)"},
                    {value:'j-n-d', text:"5-9-2024 (d-m-YYYY)"},
                    {value:'n-j-Y', text:"9-5-2024 (m-d-YYYY)"},
                    {value:'Y/n/j', text:"2024/9/5 (YYYY/m/d)"},
                    {value:'j/n/Y', text:"5/9/2024 (d/m/YYYY)"},
                    {value:'n/j/Y', text:"9/5/2024 (m/d/YYYY)"},
                ],
                timeFormat: 'H:i',
                timeFormats: [
                    {value: 'H:i', text: '08:00 24hrs'},
                    {value: 'G:i', text: '8:00 24hrs'},

                    {value: 'h:i a', text: '08:00 am'},
                    {value: 'g:i a', text: '8:00 am'},
                    {value: 'h:i A', text: '08:00 AM'},
                    {value: 'g:i A', text: '8:00 AM'},
                ],
                perPage:10,
				currentPage:1,
				totalRows:0,
                perPageOptions:[
					{value:10,text:10},
					{value:50,text:50},
					{value:100,text:100},
					{value:200,text:200},
					{value:500,text:500},
				],
				selectAll: false,
                places: [],
                serviceTypes: [],
                serviceTypesMap: [],
                selected:null,
                mapping:false,
                placemapping: false,
                mappedPlaces: [],
                responses: [],
                typeSelects: [],
                //mappedServices: [],
                errors: [],
                corrections: false,
                message: '',
                resSelected: {
					modalModelId: -1,
					tsSelectedId: -1,
					copyResId: -1,
					formTypeWork:"",
					show:false
				},
				bookingsCreated:[]
            }
        },
        computed:{
			offset(){ return (this.currentPage-1)*this.perPage },
			rowsFrom(){ return this.offset+1},
			rowsTo(){ return Math.min(this.offset+this.perPage,this.totalRows) },
			rowsMessage() {
				return this.$t("global.ajaxTable.showingNRecords", {
					from: this.rowsFrom,
					to: this.rowsTo,
					total: this.totalRows
				});
			},
            downloadFormatURL() {
                return `${process.env.VUE_APP_API_URL}/downloadFormat`
            },
			mappedServices(){
				let items = [];
				this.serviceTypes.forEach((_item,_index) => {
					if(!this.$root.isEmpty(this.typeSelects[_index].model)){
						items.push({index: _item, match:this.typeSelects[_index].model })
					}
				});
				return items;
			}
        },
        methods:{
            handleFileUpload() {
                this.file = this.$refs.file.files[0];
            },
            submitFile(reloadMapping = true) {
                this.loading     = true
                this.corrections = false
                this.message     = false
                this.errors      = []
                this.bookingsCreated = []

                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('dateFormat', this.dateFormat)
                formData.append('timeFormat', this.timeFormat)
                formData.append('limit', this.perPage)
                formData.append('offset', this.offset)
                this.$root.api.post(`/importxls`,
                    formData, {
                        timeout: 1000 * 60 * 2, //2 minutes
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then((res) => {

                    this.importResult = res.data;
                    this.loading      = false

                    //Error reading file
                    if (this.importResult.error) {
                        this.mapping     = false
                        this.corrections = true
                        this.message     = this.importResult.message
                        this.items       = []
                        this.totalRows   = 0
                        this.$root.showAlert('Error: ' + this.importResult.message, {variant:'danger'})
                        console.log('error: ' + this.importResult.message)
                        return false
                    }

                    this.errors    = this.importResult.data.errors
                    this.selected  = 1
                    this.items     = res.data.data.bookings
                    this.totalRows = res.data.data.totalBookings

                    //Not reload inputs
                    if (!reloadMapping) return false
                    if (Object.keys(this.importResult.data.errors).length > 0) {
                        this.mapping     = false
                        this.corrections = true
                        this.$root.showAlert(this.$t('global.errorsFoundAlert'), {variant:'warning'})
                        return false
                    }

                    //Map data collected
                    this.serviceTypes    = res.data.data.service_types
                    this.serviceTypesMap = res.data.data.service_types_map

                    if (Object.keys(this.serviceTypes).length > 0) {
                        this.typeSelects = []
						// eslint-disable-next-line
                        for(let place in this.serviceTypes) {
                            this.typeSelects.push({model: null})
                        }
                        this.mapping = true
                    }
					try{
						// if service type matched we select it
						this.serviceTypes.forEach((_item,_index) => {
							let foundOption = this.serviceTypesMap.find(x =>{
								return (x.text == _item || x.text.includes(_item))
							})
							if(!this.$root.isEmpty(foundOption)){
								this.typeSelects[_index].model = foundOption.value
							}
						});
					}catch(err){
						console.log(err)
					}


                    this.places = res.data.data.places
                    if (Object.keys(this.places).length > 0) {
                        this.placemapping = true
                        this.places.map(() => {
                            this.responses.push({model: null})
                        })
                    }

                }).catch(error => {
                    this.$root.handleRequestError(error)
                    this.loading = false
                });
            },
            submitFileMap() {

                this.loading = true

                let formData = new FormData()
                formData.append('file', this.file)
                formData.append('mappedPlaces', JSON.stringify(this.mappedPlaces))
                formData.append('placesFound', JSON.stringify(this.importResult.data.placesFound))
                formData.append('mappedServices', JSON.stringify(this.mappedServices))
                formData.append('dateFormat', this.dateFormat)
                formData.append('timeFormat', this.timeFormat)
                formData.append('confirmation', true)
                this.$root.api.post(`/importxls`, formData).then((res) => {

                    this.corrections = false
                    this.message     = false
                    this.loading     = false

                    if (res.data.error) {
                        this.corrections = true
                        this.message     = res.data.message
                        this.$root.showAlert(res.data.message, {variant:'danger'})
                        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
                        console.log(res.data.message)
                        return false
                    }

                    //Reload page
                    this.$root.showAlert(this.$t('global.successfullyRegistered'))
                    this.reload()
                    this.bookingsCreated = res.data.data.bookings

                }).catch(error => {
                    this.$root.handleRequestError(error)
                    this.loading = false
                })
            },
            updateTable(){
				this.$refs.table.refresh()
			},
            setData(data) {

                //Quitamos si existe ya uno previamente y fue actualizado
                this.mappedPlaces.map((match, index) => {
                    if (match.index == data.index) {
                        this.mappedPlaces.splice(index, 1)
                    }
                })
                this.mappedPlaces.push(data)
            },
            rowClass(item) {
                //Indicamos donde se encuentra el error dentro de los datos
                for(let error of this.errors) {
                    if (item.indice === error.indice) return 'table-danger'
                }
            },
            reload() {
                this.mapping   = false
                this.items     = []
                this.totalRows = 0
                this.$refs.file.value = null
                this.responses = []
            },
            resView(item) {
                this.resSelected.tsSelectedId = item.id;
                this.resSelected.copyResId    = -1;
                this.resSelected.modalModelId = item.reservationId;
                this.resSelected.show         = true;

                //configuramos el estado de formulario formService
                this.resSelected.formTypeWork = "viewForm";
            },
            copyCurrentRes(){
				const aux = this.resSelected.modalModelId
				this.resSelected.modalModelId = -1
				this.$refs.single.copyFromId(aux)
			},
        },
        mounted(){}
    }
</script>

<style scoped>
	.active {
		color: cornflowerblue;
	}
	#perPageSelector{
		width: 80px
	}
</style>
